import formInputOrder from "@global/components/global/formInputOrder";

function initAddBookmark() {
	$(".bookmarks_Btn")
		.children()
		.on("click", function (event) {
			function DetectBrowser() {
				var sAgent = navigator.userAgent.toLowerCase();
				this.isIE = sAgent.indexOf("msie") !== -1; // IE6-10
				this.isSa = sAgent.indexOf("safari") !== -1; // safari
				this.isOp = sAgent.indexOf("opera") !== -1; // opera
				this.isNN = sAgent.indexOf("netscape") !== -1; // netscape
				this.isCh = sAgent.indexOf("chrome") !== -1; // chrome
				this.isIE11 = sAgent.indexOf("gecko") !== -1; // IE11
				this.isMa = this.isIE; // marthon
			}

			var oBrowser = new DetectBrowser();

			if (oBrowser.isSa && oBrowser.isCh) {
				nowBrand.alert(
					"您的瀏覽器不支援，請按" +
						(navigator.userAgent.toLowerCase().indexOf("mac") !== -1 ? "Command/Cmd" : "CTRL") +
						"+D 即可加入書籤。"
				);
				event.preventDefault();
				return false;
				// only wibkid
			}

			if (oBrowser.isIE11) {
				var url = window.location;
				var title = document.title;
				window.external.addFavorite(url, title);
				event.preventDefault();
				return false;
				// only IE
			}
		});
}

function initNewsletterPopup() {
	const focusInput = () => {
		$(".newsletter .txt").focus();
	};

	focusInput();

	$("#btnSubscribe, #btnNewletter, .btnNewsletter")
		.off("click")
		.on("click", function (event) {
			const strEmail = $(this).closest("form").children('input[type="text"]').val();
			const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i;

			if (strEmail === "") {
				nowBrand.alert("請填寫 E-mail 信箱 !", "提示訊息", focusInput);
			} else if (!emailPattern.test(strEmail)) {
				nowBrand.alert("請填寫有效的 E-mail 信箱 !", "提示訊息", focusInput);
			} else {
				$.post(
					"/Home/Newsletter/",
					{ email: strEmail },
					function (data) {
						if (data.result) {
							$(window).trigger("closeDialogPopup");
							if (nowBrand.globalConfig.id === "mercci22") {
								nowBrand.alert("謝謝。您將收到電子郵件以確認訂閱喔！", "提示訊息");
							} else {
								nowBrand.alert("訂閱電子報完成 !", "提示訊息");
							}
						} else {
							nowBrand.alert(data.errorMsg, "提示訊息", focusInput);
						}
					},
					"json"
				);
			}

			event.preventDefault();
		});

	formInputOrder({
		inputArray: [".newsletter .txt"],
		submitButton: "#btnSubscribe",
	});
}

export default {
	initAddBookmark: initAddBookmark,
	initNewsletterPopup: initNewsletterPopup,
};
